(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-about-template"] && !window.DesignMode) return;
  try {
    
document.querySelectorAll('#indexAboutSection .sectionBox .textBox .showMore').forEach(function(button) {
  button.addEventListener('click', function() {
    if (button.classList.contains('active')) {
      button.textContent = 'Read More >';
      button.classList.remove('active');
    } else {
      button.textContent = 'See less >';
      button.classList.add('active');
    }

    const textElement = button.closest('.textBox').querySelector('.text');
    if (textElement) {
      textElement.classList.toggle('show');
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
